'use client';

import { useState } from 'react';

import { logout } from '@/actions/auth/logout.action';
import { Loader2Icon, LogOut } from 'lucide-react';

import { Button } from '../ui/button';

export const LogoutButton = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Button
      variant='secondary'
      className='w-full'
      disabled={loading}
      onClick={async () => {
        setLoading(true);

        await logout();
      }}
    >
      {loading ? (
        <Loader2Icon className='mr-2 animate-spin' />
      ) : (
        <LogOut className='mr-2' />
      )}
      Cerrar sesión
    </Button>
  );
};
